/* global AbortController */
import { isAuthenticated } from '../utils/authHelper';
import React, { Component, Fragment } from 'react';
import Header from './Header';
import CSVGenerator from '../utils/json2csv';
import _ from 'lodash';
import moment from 'moment';
import { browserHistory } from 'react-router';
import Table from './Table';
import userdata from '../config/jwt_token'
import { getExcelUploadReport } from '../utils/PaymentRequestApiUtils';
import { TextField, Button, Snackbar, LinearProgress, Dialog, DialogContent, Tabs, Tab } from '@material-ui/core';
import { PURCHASE_EXCEL_UPLOAD_COULUMNS } from '../constants/tableColumns';

const viewsConfig = [
  {
    name: 'Purchase Report',
    dataKey: 'purchase',
    key: 0
  }
]

class TallyExcelUpload extends Component {
  constructor() {
    super();
    if (!isAuthenticated()) {
      browserHistory.push('/')
    }
    this.state = {
      currentView: 0,
      data: [],
      fromDate: '',
      toDate: '',
      fromDateShow: '',
      toDateShow: '',
      fromDateErr: false,
      fromDateErrText: '',
      toDateErr: false,
      toDateErrText: '',
      inProgress: false,
      snackMessage: "",
      snackOpen: false,
      validationsDialogOpen: false,
      validationErrors: [],
      dialogBoxText: "",
      showDownloadButton: false,
      paymentsReportColumns: [],
      accountingReportColumns: [],
      billSubmissionReportColumns: [],
    }
    this.abortController = null;
    this.handleChange = this.handleChange.bind(this);
    this.submitFilter = this.submitFilter.bind(this);
    this.clearFilter = this.clearFilter.bind(this);
    this.generateCSV = this.generateCSV.bind(this);
    this.handleCloseSnack = this.handleCloseSnack.bind(this);
    this.handleFetchData = this.handleFetchData.bind(this);
    this.cancelRequest = this.cancelRequest.bind(this);
  }

  componentWillMount() {
    if (userdata) {
      let role = userdata.role
      if (role !== 'root' && role !== 'Super Central Finance' && role !== 'City Finance' && role !== 'Report Viewer') {
        browserHistory.push('/payment/reports')
      }
    }
    this.setState({
      showDownloadButton: true,
      purchaseReportColumns: PURCHASE_EXCEL_UPLOAD_COULUMNS
    })
  }
  componentDidMount() {
    this.handleFetchData()
  }

  componentWillUnmount() {
    // Abort any in-flight request to prevent state updates on unmounted component
    if (this.abortController) {
      this.abortController.abort();
    }
  }

  handleViewChange = (event, newValue) => {
    this.setState({ currentView: newValue });
  };

  handleChange = (props) => (event, index, value) => {
    this.setState({ [props]: event.target.value, [props + 'Err']: false, [props + 'ErrText']: '' })
  }

  async submitFilter() {

    if (this.state.toDateShow !== '' && this.state.toDateShow < this.state.fromDateShow) {
      this.setState({ snackOpen: true, snackMessage: 'From date should be less than To date' })
      return
    }

    if (this.state.fromDateShow !== '' && this.state.fromDateShow > this.state.toDateShow) {
      this.setState({ snackOpen: true, snackMessage: 'To date should be greater than From date' })
      return
    }
    this.setState({ fromDate: this.state.fromDateShow, toDate: this.state.toDateShow }, () =>
      this.handleFetchData({ 
        from_date: this.state.fromDate, 
        to_date: this.state.toDate,
        view: viewsConfig[this.state.currentView].dataKey
      })
    )

  }

  handleFetchData(filters = {}) {
    // Abort any previous in-flight request
    if (this.abortController) {
      this.abortController.abort();
    }
    this.abortController = new AbortController();

    this.setState({ inProgress: true }, () => {
      getExcelUploadReport(filters, this.abortController.signal).then(response => {
        if (response) {
          if (response.status === 'success') {
            const data = response.data.map((cur)=>({
              ...cur,
              payment_request_date: (cur.payment_request_date) ? moment(cur.payment_request_date).format('YYYY-MM-DD hh:mm A') : cur.payment_request_date
            }))
            this.setState({ data: data, inProgress: false })
          }
          else if (response.status === 'cancelled') {
            // Request was cancelled by user or timed out — do nothing
            return;
          }
          else {
            this.setState({ snackMessage: response.message || 'Something went wrong', snackOpen: true, inProgress: false })
          }
        }
      })
    })
  }

  cancelRequest() {
    if (this.abortController) {
      this.abortController.abort();
    }
    this.setState({ inProgress: false, snackMessage: 'Request cancelled', snackOpen: true });
  }


  handleCloseSnack() {
    this.setState({ snackOpen: false })
  }

  clearFilter() {
    this.setState({ fromDate: '', toDate: '', fromDateShow: '', toDateShow: '', fromDateErr: false, fromDateErrText: '', toDateErr: false, toDateErrText: '' })
    this.handleFetchData();
  }

  getExcelUploadPurchaseReportCSVData = (rawData) => {
    let data = rawData.map((cur)=> {
      return {
        'L1 Approver Date': cur.approver1_date ? cur.approver1_date : '',
        'Voucher Type Name': cur.voucher_type ? cur.voucher_type : '',
        'Voucher Number': cur.entry_code ? cur.entry_code : '',
        'Ledger Name': cur.ledger_name ? cur.ledger_name : '',
        'Ledger Amount': cur.ledger_amount ? cur.ledger_amount : '',
        'Ledger Amount Dr/Cr': cur.ledgerAmountDrCr ? cur.ledgerAmountDrCr : '',
        'Cost Allocation for - Cost Centre': cur.cost_center ? cur.cost_center : '',
        'Cost Allocation for - Amount': cur.cost_center_amount ? cur.cost_center_amount : '',
        'Bill Type of Ref': cur.billTypeRef ? cur.billTypeRef : '',
        'Bill Name': cur.invoice_no ? cur.invoice_no : '',
        'Bill Amount': cur.ledger_amount ? cur.ledger_amount : '',
        'Bill Amount - Dr/Cr': cur.ledgerAmountDrCr ? cur.ledgerAmountDrCr : '',
        'Reference No.': cur.invoice_no ? cur.invoice_no : '',
        'Reference Date': cur.accounting_date ? cur.accounting_date : '',
        'Voucher Narration': cur.narration ? cur.narration : '',
        'PR Index': cur.payment_request_id ? cur.payment_request_id : '',
        'Ledger_Name_Key': cur.ledger_name_key ? cur.ledger_name_key : '',
        'Ledger_Type': cur.ledger_type ? cur.ledger_type : '',
        'ZAPS_Ledger_Name': cur.zaps_ledger_name ? cur.zaps_ledger_name : '',
        'ZAPS_GST_Slab': cur.zaps_gst_slab ? cur.zaps_gst_slab : '',
        'Bill Link': cur.bill_link ? cur.bill_link : '',
        'Supporting Document Link': cur.supporting_document_link ? cur.supporting_document_link : '',
        'EXP_FTM': cur.exp_ftm ? cur.exp_ftm : '',
        'City': cur.city ? cur.city : '',
        'Setup Flag': cur.setup_flag ? cur.setup_flag : '',
        'Transaction_Date': cur.transaction_date ? cur.transaction_date : '',
        'Transaction_ID': cur.transaction_id ? cur.transaction_id : '',
        'Settlement_Type': cur.settlement_type ? cur.settlement_type : '',
        'GST Availment Type': cur.gst_avail_type ? cur.gst_avail_type : '',
        'PO_No.': cur.po_no ? cur.po_no : '',
        'Payment_Request_Date': cur.payment_request_date ? cur.payment_request_date : '',
        'GST_Map_ID': cur.gst_map_id ? cur.gst_map_id : '',
        'ZAPS_Entity_Type': cur.zaps_entity_type ? cur.zaps_entity_type : '',
        'Vendor Name': cur.vendor_name ? cur.vendor_name : '',
      }
    });
    let headers = _.map(PURCHASE_EXCEL_UPLOAD_COULUMNS,'Header');
    return {
      data: data,
      headers: headers,
      filename: 'ZAPS_TALLY_EXCEL_UPLOAD_PURCHASE_REPORT'
    }
  }

  generateCSV = () => {
    let csvData = this.getExcelUploadPurchaseReportCSVData(this.state.data);
    CSVGenerator(csvData.headers, csvData.data, csvData.filename)
  }

  render() {
    return (
      <Fragment>
        <Header />
        <div className="zaps-page-wrap">
          <div className="zaps-page-header">
            <div>
              <h2 className="zaps-page-title">Tally Excel Upload</h2>
              <p className="zaps-page-subtitle">Upload and sync Tally-compatible Excel exports</p>
            </div>
          </div>
        <Tabs value={this.state.currentView} onChange={this.handleViewChange} aria-label="report views">
          {viewsConfig.map((view, index) => (
            <Tab key={index} label={view.name} />
          ))}
        </Tabs>
        <h4 style={{ textAlign: 'center' }}>
          {viewsConfig[this.state.currentView].name} - Details showing from {this.state.fromDate && this.state.toDate ? this.state.fromDate : moment().startOf('month').format("YYYY-MM-DD")} to {this.state.toDate && this.state.fromDate ? this.state.toDate : moment().endOf('month').format("YYYY-MM-DD")}</h4>
        <div style={{ display: 'flex', justifyContent: 'space-between', margin: '20px', flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            <div>
            Select L1 Approval Date Range:&nbsp;&nbsp;&nbsp;&nbsp;
              <TextField
                id="date"
                label="From Date"
                type="date"
                InputLabelProps={{
                  shrink: true,
                }}
                value={this.state.fromDateShow}
                onChange={this.handleChange('fromDateShow')}
                style={{ marginRight: '20px' }}
                error={this.state.fromDateErr}
                helperText={this.state.fromDateErrText}
                margin='normal'
              />
              <TextField
                id="date"
                label="To Date"
                type="date"
                InputLabelProps={{
                  shrink: true,
                }}
                value={this.state.toDateShow}
                onChange={this.handleChange('toDateShow')}
                style={{ marginRight: '20px' }}
                error={this.state.toDateErr}
                helperText={this.state.toDateErrText}
                margin='normal'
              />
            </div>
            <div>
              <Button 
                variant="contained" 
                size="large" 
                color="primary" 
                disabled={this.state.fromDateShow === '' || this.state.toDateShow === ''} 
                onClick={this.submitFilter.bind(this)}
                style={{ marginRight: '20px', marginTop: '25px' }}
              >
                Submit Filter
              </Button>
              <Button 
                variant="contained" 
                size="large" 
                color="primary" 
                disabled={this.state.fromDateShow === '' && this.state.toDateShow === ''} 
                onClick={this.clearFilter.bind(this)}
                style={{ background: 'red', marginTop: '25px' }}
              >
                Clear Filter
              </Button>
            </div>
          </div>
          <div style={{ marginTop: '25px' }} >
            {this.state.showDownloadButton && (
              <Button 
                variant="contained" 
                size="large" 
                color="primary" 
                disabled={this.state.data.length === 0} 
                onClick={this.generateCSV.bind(this)}
                style={{ marginRight: '20px' }}
              >
                Download CSV
            </Button>
            )}
          </div>
    </div>
        <Table 
          columns={this.state.purchaseReportColumns} 
          data={this.state.data} 
        />
        <Dialog
          open={this.state.inProgress}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <div style={{ textAlign: 'center', minWidth: '300px' }}>
              Loading report data...
              <br />
              <span style={{ fontSize: '12px', color: '#888' }}>This may take a while for large date ranges</span>
              <br /><br />
              <LinearProgress />
              <br />
              <Button 
                variant="outlined" 
                size="small" 
                onClick={this.cancelRequest}
                style={{ color: '#f44336', borderColor: '#f44336' }}
              >
                Cancel
              </Button>
            </div>
          </DialogContent>
        </Dialog>
        <Snackbar
          open={this.state.snackOpen}
          message={this.state.snackMessage}
          autoHideDuration={2500}
          onClose={this.handleCloseSnack.bind(this)}
        />
          
        </div>{/* end zaps-page-wrap */}
      </Fragment>
    )
  }
}

export default TallyExcelUpload;



// WEBPACK FOOTER //
// ./src/components/TallyExcelUpload.js